<template>
  <div class="rss-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t("commonMsg.new") }}</span>
      <span v-else>{{ $t("commonMsg.edit") }}</span>
      <div>
        <button class="global-button-style" @click="goBack()">
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t("commonMsg.save") }}
        </button>
        <!-- <button class="global-button-style" @click="toPublic('ruleForm')">
          {{ $t("commonMsg.release") }}
        </button> -->
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="120px"
          :model="rss"
          @submit.native.prevent
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item :label="$t('update.category')">
            <p>{{ $route.query.categoryName }}</p>
          </el-form-item>
          <el-form-item label="封面">
            <div class="rss-upload-container">
              <input
                v-show="false"
                ref="coverUploader"
                type="file"
                accept="image/*"
                @change="rssCoverSelect"
              />

              <div class="rss-cover-main">
                <div class="rss-cover-warp">
                  <template v-if="rss.cover">
                    <el-image
                      class="rss-cover-imgs"
                      :src="rss.cover"
                      fit="fill"
                      :lazy="true"
                      :preview-src-list="[rss.cover]"
                    ></el-image>
                    <div class="rss-cover-btn">
                      <i
                        class="el-icon-delete"
                        @click.stop="rss.cover = ''"
                      ></i>
                    </div>
                  </template>
                </div>
                <div
                  class="rss-upload-btn"
                  @click="$refs.coverUploader.click()"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="RSS名称" prop="title">
            <el-input
              v-model="rss.title"
              class="fl"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="RSS地址" prop="url">
            <el-input v-model="rss.url" class="fl"></el-input>
          </el-form-item>
          <el-form-item label="是否发布">
            <el-radio v-model="rss.public" :label="1">是</el-radio>
            <el-radio v-model="rss.public" :label="0">否</el-radio>
          </el-form-item>
          <!-- <el-form-item label="是否公共源">
            <el-radio-group v-model="rss.publicFeed">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item label="设备型号组" prop="modelGroups">
            <el-checkbox-group v-model="rss.modelGroups">
              <el-checkbox
                v-for="item in modelData"
                :key="item._id"
                :label="item._id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="描述">
            <el-input
              type="textarea"
              :rows="5"
              v-model="rss.description"
              resize="none"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OSS from "ali-oss";
export default {
  computed: {
    ...mapGetters(["buckets"])
  },

  data() {
    return {
      modelData: [],
      langData: [],
      rss: {
        cover: "",
        modelGroups: [],
        publicFeed: 1,
        public: 1,
        fileType: 1,
        url: "",
        parent: this.$route.query.categoryId,
        title: "",
        description: "",
        sourceType: 0
      },
      isSave: false,
      ossClient: null,
      rules: {
        url: [
          {
            required: true,
            message: this.$t("placeholder.enter"),
            trigger: "blur"
          }
        ],
        title: [
          {
            required: true,
            message: this.$t("placeholder.enter"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    // 上传封面
    async rssCoverSelect(el) {
      let file = el.target.files[0];
      this.ossClient = await this.getOssClient();
      this.rss.cover = await this.uploadFiles(file);
      this.$refs.coverUploader.value = "";
    },

    getOssClient() {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await await this.$http.aliyunSts();
          let { region, bucket } = this.buckets["onyx-static"];
          let creds = res.data;
          let client = new OSS({
            region,
            accessKeyId: creds.AccessKeyId,
            accessKeySecret: creds.AccessKeySecret,
            stsToken: creds.SecurityToken,
            bucket
          });
          return resolve(client);
        } catch (error) {
          reject(error);
        }
      });
    },

    async uploadFiles(file) {
      return new Promise(async (resolve, reject) => {
        try {
          let format = file.name.split(".").pop();
          let key = `rss/cover/${this.random_string()}.${format}`;

          this.progress = 0;
          let imgData = await this.ossClient.multipartUpload(key, file, {
            progress: p => {
              // progress is generator
              this.progress = parseInt(p.toFixed(2) * 100);
            }
          });
          let url = imgData.res.requestUrls[0].split("?")[0];
          resolve(url);
        } catch (error) {
          reject(error);
        }
      });
    },

    random_string(len) {
      len = len || 32;
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },

    async getModelGroups() {
      let res = await this.$http.getModelGroups();
      this.modelData = res.data.results;
    },
    async getLangGroups() {
      let res = await this.$http.getLangGroups();
      this.langData = res.data.results;
    },

    async getRssListDetails() {
      let res = await this.$http.getRssListDetails(this.$route.query.id);
      res.data.cover = res.data.cover ? res.data.cover : "";
      this.rss = Object.assign({}, res.data);
    },

    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.$route.query.id) {
            this.edit();
          } else {
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    // toPublic(formName) {
    //   this.$refs[formName].validate(async valid => {
    //     if (valid) {
    //       if (this.$route.query.id) {
    //         this.faq.public = 1;
    //         this.edit();
    //       } else {
    //         this.rss.public = 1;
    //         this.create();
    //       }
    //     } else {
    //       return false;
    //     }
    //   });
    // },

    async create() {
      let body = Object.assign({}, this.rss);
      await this.$http.createRssList(body);
      this.elMsg(this.$t("alertMsg.addSuccess"), "success");
      this.goBack();
    },

    async edit() {
      let body = Object.assign({}, this.rss);
      await this.$http.updateRssList(this.$route.query.id, body);
      this.elMsg(this.$t("alertMsg.editSuccess"), "success");
      this.goBack();
    },

    goBack() {
      this.$router.push({
        name: "rss",
        query: {
          categoryId: this.$route.query.categoryId,
          categoryName: this.$route.query.categoryName
        }
      });
    }
  },
  mounted() {
    this.getModelGroups();
    if (!this.$route.query.id) return;
    this.getRssListDetails();
  }
};
</script>

<style lang="scss">
.rss-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .rss-upload-container {
        flex: 1;
        display: flex;
        align-items: center;
        .rss-cover-main {
          display: flex;
          .rss-cover-warp {
            position: relative;
            &:hover {
              .rss-cover-btn {
                display: flex;
              }
            }
            .rss-cover-btn {
              width: 80px;
              display: none;
              justify-content: space-around;
              align-items: center;
              position: absolute;
              bottom: 11px;
              left: 0;
              box-sizing: border-box;
              padding: 6px;
              background: rgba($color: $globalBGColor, $alpha: 1);
              border-bottom-left-radius: 4px;
              border-bottom-right-radius: 4px;
              > i {
                color: #fff;
                cursor: pointer;
              }
            }
          }
        }
        .rss-cover-imgs {
          margin-right: 10px;
          width: 80px;
          height: 80px;
          border-radius: 4px;
        }
        .rss-upload-btn {
          width: 78px;
          height: 78px;
          border: 1px dashed #c0ccda;
          border-radius: 4px;

          background-color: #fbfdff;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          &:hover {
            border-color: $globalLessBGColor;
            > i {
              color: $globalBGColor;
            }
          }
          > i {
            font-size: 20px;
            color: #8c939d;
          }
        }
      }
    }
  }
}
</style>
